import {
  isNotNull,
  OnboardingStepType,
  OnboardingWorkflowFragment,
  OrganizationDetailFragment,
  useOrgAdminsQuery,
} from '@alice-financial/alice-sdk'
import { HealthcheckStatusResult, HealthcheckType } from '../types'
import { getOnboardingStepAssignee } from '../utils/onboardingWorkflowUtils'

export const useCompanyProfileStatus = (
  org: OrganizationDetailFragment,
  onboardingWorkflow?: OnboardingWorkflowFragment | null
): HealthcheckStatusResult => {
  const { data: orgAdminsData } = useOrgAdminsQuery({ orgId: org.id })
  const assignee = getOnboardingStepAssignee(onboardingWorkflow, OnboardingStepType.CompanyProfile)

  const admins = orgAdminsData?.usersWithRole?.filter(isNotNull) || []
  const hasLabeledAdmins = admins.some((admin) => admin.role?.label)

  const healthcheckTitle = 'Company roles'

  const baseProperties = {
    assignee,
    healthcheckTitle,
    primary: healthcheckTitle,
    healthcheckType: HealthcheckType.CompanyProfile,
  } as const

  if (!hasLabeledAdmins && !org.isOnboarded) {
    return {
      status: 'incomplete',
      secondary: 'Let us know who is responsible for your payroll and financial operations',
      ...baseProperties,
    }
  }

  return {
    status: 'complete',
    secondary: 'Administrator roles assigned',
    ...baseProperties,
  }
}
